import { CloseGreyIcon, MinusBlackIcon, PlusBlackIcon, PlusThickWhiteIcon } from "../../../assets/icons";
import { useCart } from "../../../hooks/useCart";
import { TagStyleType } from "../../../models/base/TagStyleType";
import { CartProduct } from "../../../models/helpers/product";
import TagTypes from "../../shared/products cards/TagTypes";
import { Product } from "../../shared/products cards/types";


interface ProductVariantViewProps {
    product: Product;
    onClose: () => void;
    cart: ReturnType<typeof useCart>;
    primaryColor?: string;
    tagTypes?: TagStyleType;
}

export const ProductVariantView = ({ product, onClose, cart, primaryColor, tagTypes }: ProductVariantViewProps) => {

    const calculateTotalPrice = (): number => {
        return product.productVariants.reduce((total, variant) => {
            const quantity = cart.getProductVariantQuantity(variant.id);
            return total + (variant.price * quantity);
        }, 0);
    }

    return (
        <section className="modal-section product-variant" onClick={onClose}>
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">Izaberi varijantu</div>
                                <div className="description-text">
                                    Filteri će prikazati rezultat primenjen na sve stavke menija<br />
                                </div>
                            </div>
                            <div className="modal-button-div" onClick={onClose}>
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                            </div>
                        </div>
                        <div className="div-block-105">
                            <div className="product-variant-image-div">
                                <img src={product.imageUrl + "@lg.webp"} loading="lazy" alt={product.name} className="product-variant-image" />
                            </div>
                            <div className="product-variant-name">{product.name}</div>
                            <div className="description-text product-variant-product-description">{product.description}</div>
                            <div className="description-text product-variant-product-description2">{product.description2}</div>

                            <TagTypes
                                style={tagTypes}
                                primaryColor={primaryColor}
                                tags={product.tags}
                            />

                            <div className="product-variant-listi-div">
                                {product.productVariants.map(variant => (
                                    <div className="product-variant-div">

                                        <div className="product-variant-label">{variant.label}</div>

                                        <div className="product-variant-price-block">

                                            {variant?.oldPrice && (
                                                <div className="div-block-106">
                                                    <div className="product-variant-price sale">
                                                        {variant.oldPrice}<span className="text-span-8">,00 RSD</span>
                                                    </div>
                                                    <div className="sale-hr"></div>
                                                </div>
                                            )}

                                            <div className="product-variant-price">
                                                <span>
                                                    {variant.price}<span className="text-span-8">,00 RSD</span>
                                                </span>
                                            </div>

                                            <div className="client-basket-selected-item-quatity-block">
                                                <div className="client-basket-selected-item-quantity-icon-div white-bg"
                                                    onClick={() => {
                                                        cart.changeProductVariantQuantity(variant.id, cart.getProductVariantQuantity(variant.id) - 1);
                                                    }}
                                                >
                                                    <img src={MinusBlackIcon} loading="lazy" alt="" className="icon-size-12" />
                                                </div>
                                                <div className="client-basket-selected-item-quantity-div">
                                                    <div>{cart.getProductVariantQuantity(variant.id)}</div>
                                                </div>
                                                <div
                                                    className="client-basket-selected-item-quantity-icon-div"
                                                    style={{ background: `linear-gradient(0deg, ${primaryColor}, ${primaryColor}aa)`, color: "white" }}
                                                    onClick={() => {
                                                        const currentQty = cart.getProductVariantQuantity(variant.id);
                                                        if (currentQty === 0) {
                                                            cart.addProductVariant({
                                                                ...product,
                                                                quantity: 1,
                                                                selectedVariant: variant
                                                            });
                                                        } else {
                                                            cart.changeProductVariantQuantity(variant.id, currentQty + 1);
                                                        }
                                                    }}
                                                >
                                                    <img src={PlusThickWhiteIcon} loading="lazy" alt="" className="icon-size-12" />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                ))}

                            </div>
                            <div className="div-hr product-variant"></div>
                            <div className="product-variant-total-price">
                                {calculateTotalPrice()}<span className="text-span-9">{calculateTotalPrice().toFixed(2).substring(calculateTotalPrice().toFixed(2).length - 3)} RSD</span> 
                            </div>
                        </div>
                        {/* <div className="modal-buttons">
                            <div className="button-secondary medium">
                                <div>Otkaži</div>
                            </div>
                            <div className="button-primary medium client-gold">
                                <div>Dodaj u korpu</div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </section>
    );
}